import i18n from '@/i18n';
import store from '@/store';
import router from '@/router';
import S_scope from '@/service/api/v1/scope';
import H_time from '@/helpers/time';
import H_common from '@/helpers/common';
import Spare_file from '@/spare/file';
import Spare_filePhotos from '@/spare/file-photos';

export default {
  setFileExtension(url) {
    if (!url) return;
    const _url = url.substring(1 + url.lastIndexOf('/'));
    return _url
      .substring(_url.lastIndexOf('.'))
      .split('?')[0]
      .split('#')[0]
      .toLowerCase();
  },
  setFileNameFromUrl(url) {
    if (!url) return '';
    // 移除查詢參數 ? 和錨點 #
    const urlWithoutQuery = url.toString().split('?')[0].split('#')[0];
    // 匹配最後一個路徑段（不管有沒有副檔名）
    const filename = urlWithoutQuery.match(/.*\/([^/]+)$/);
    return filename && filename.length > 1
      ? decodeURI(filename[1])
      : '';
  },
  getFileName(file) {
    if (!file) return '';
    const match = file.match(/^(.+?)(?=\.\w+$)/);
    return match ? match[1] : file;
  },
  setFileIconFromUrl(url) {
    if (!url) return;
    const fileExtension = this.setFileExtension(url)
    .substring(1)
    .toLowerCase();
    return this.setFileIconFromType(fileExtension);
  },
  setFileIconFromType(fileExtension) {
    if (!fileExtension) return require('@/assets/image/thumbnail_file/other-other.png');
    let fileIcon;
    const lowerCaseFileExtension = fileExtension.toLowerCase();
    Spare_filePhotos.filePhotos.forEach(filePhoto => {
      if (filePhoto.file.includes(lowerCaseFileExtension)) {
        fileIcon = filePhoto.image;
      }
    });
    return fileIcon
      ? fileIcon
      : require('@/assets/image/thumbnail_file/other-other.png');
  },
  setIndex(rawDataList, selectedTabId) {
    return rawDataList.map(rawData => {
      const {
        id,
        name,
        type,
        file_path,
        updated_at,
        created_at,
        folder_path,
        is_secret: isSecret,
        created_user: createdUser,
        version_number: versionNumber,
        file_type: fileType,
        file_uuid_path,
        is_share,
      } = rawData;
      let resultData = {
        id,
        name: name ? name : i18n.t('無權限'),
        type,
        createdUser,
        createdAt: H_time.getDateDashFormat(created_at, 'YYYY-MM-DD HH:mm:ss'),
        updatedAt: H_time.getDateDashFormat(updated_at, 'YYYY-MM-DD HH:mm:ss'),
        isSecret,
        hasScope: name ? true : false,
      };
      if (type === 'file_folder') {
        resultData = {
          ...resultData,
          path: this.setPath(folder_path),
          type: 'fileFolder',
        };
        if (
          selectedTabId === 'thisUnit' ||
          selectedTabId === 'toOtherUnits'
        ) {
          resultData = {
            ...resultData,
            info: {icon: 'icon-info'},
            iconNavDrawer: [
              {
                value: 'editFolder',
                text: '編輯',
              },
              {
                value: 'moveFolder',
                text: '移動',
              },
              {
                value: 'deleteFolder',
                text: '刪除',
                color: 'red',
              },
            ],
            isShare: is_share === 1,
          };
        }
        if (selectedTabId === 'systemFolder') {
          resultData = {
            ...resultData,
            info: {icon: 'icon-info'},
          };
        }
      } else if (type === 'file') {
        resultData = {
          ...resultData,
          path: this.setPath(file_path),
          versionNumber,
          fileType,
          parentFolderId: file_uuid_path
            ? this.setParentFolderId(file_uuid_path)
            : router.currentRoute.query.id
            ? router.currentRoute.query.id
            : '',
        };
        if (
          selectedTabId === 'thisUnit' ||
          selectedTabId === 'toOtherUnits'
        ) {
          resultData = {
            ...resultData,
            iconNavDrawer: [
              {
                value: 'editFile',
                text: '編輯',
              },
              {
                value: 'moveFile',
                text: '移動',
              },
              {
                value: 'deleteFile',
                text: '刪除',
                color: 'red',
              },
            ],
          };
        } else if (selectedTabId === 'systemFolder' && S_scope.$_isAvailable(['system-file-delete'])) {
          resultData = {
            ...resultData,
            iconNavDrawer: [
              {
                value: 'deleteFile',
                text: '刪除',
                color: 'red',
              },
            ],
          };
        }
      }
      return resultData;
    })
  },
  setShowFolder(rawData) {
    const {
      id,
      name,
      is_secret,
      is_public,
      share_factories,
      folder_path,
      folder_uuid_path,
      users: scopeAvatars,
      user_factory_role_templates,
      user_factory_roles,
    } = rawData;
    let scopeRoles = user_factory_role_templates.map(role => role.name).join(`, `);
    if (user_factory_roles.length) {
      if (scopeRoles) scopeRoles += `, `;
      scopeRoles += user_factory_roles.map(role => role.name).join(`, `);
    }
    return {
      id,
      name,
      isSecret: is_secret === 1,
      isPublic: is_public ? '是' : '否',
      path: this.setPath(folder_path),
      scopeAvatars,
      scopeRoles,
      pathWithLink: this.setPathWithLink(folder_path, folder_uuid_path),
      shareFactories: share_factories.map(factory => factory.name).join(`, `),
    };
  },
  setUpdateFolder(rawData) {
    const {
      id,
      name,
      users,
      folder_path,
      share_factories,
      is_secret: isSecret,
      is_public: isPublic,
      user_factory_roles,
      user_factory_role_templates,
    } = rawData;
    return {
      id,
      name,
      path: this.setPath(folder_path),
      isSecret,
      isPublic,
      moveFolderId: '',
      moveFolderPath: '無',
      scopeRoles: [user_factory_roles.map(role => role.id), user_factory_role_templates.map(role => role.id)],
      scopeAvatars: users.map(user => user.id),
      scopeAvatarsSelectValue: users,
      isCreate: false,
      shareFactories: share_factories.map(factory => factory.id),
    };
  },
  setShowFile(rawData) {
    const {
      id,
      name,
      updated_user: updatedUser,
      updated_at,
      des,
      created_user: createdUser,
      created_at,
      file_path,
      remark,
      remark_updated_user: remarkUpdatedUser,
      remark_updated_at,
      source_url: sourceUrl,
      file_type: fileType,
      version_number: versionNumber,
      file_folder,
      is_invalid: isInvalid,
      share_factories,
      is_system,
    } = rawData;
    const attach = {
      id,
      name,
      url: sourceUrl,
      hasScope: sourceUrl ? true : false,
      fileType,
      chipList: [],
      showMoreBtn: false,
      versionNumber,
    };
    if (isInvalid) {
      attach.chipList = [Spare_file.invalid];
    }
    const result = {
      id,
      name,
      updatedUser,
      updatedAt: H_time.getDateDashFormat(updated_at, 'YYYY-MM-DD HH:mm:ss'),
      des,
      createdUser,
      createdAt: H_time.getDateDashFormat(created_at, 'YYYY-MM-DD HH:mm:ss'),
      isSystem: is_system === 1,
      path: this.setPath(file_path),
      lawList: H_common.setLawList(rawData),
      remark,
      remarkUpdatedUser,
      remarkUpdatedAt: H_time.getDateDashFormat(remark_updated_at, 'YYYY-MM-DD HH:mm:ss'),
      attach,
      fileType,
      versionNumber,
      folderId: file_folder ? file_folder.id : '',
      isInvalid,
      shareFactories: share_factories.map(factory => factory.name).join(`, `),
    };
    return result;
  },
  setUpdateFile(rawData) {
    const {
      id,
      name,
      des,
      remark,
      file_type: fileType,
      is_invalid: isInvalid,
      file_folder,
      share_factories,
    } = rawData;
    return {
      id,
      name,
      des,
      remark,
      lawList: H_common.setLawList(rawData),
      fileType,
      attaches: [],
      isInvalid,
      folderId: file_folder.id,
      shareFactories: share_factories.map(factory => factory.id),
    };
  },
  setPathWithLink(rawPath, rawUUIDPath) {
    const factoryId = store.state.app.factory.id;
    const folderPath = rawPath.split('/');
    const folderPathUUID = rawUUIDPath.split('/');
    const path = folderPath.map((_path, index) => {
      let resultPath = {text: _path};
      if (index !== folderPath.length -1) {
        resultPath = {
          ...resultPath,
          id: folderPathUUID[index],
          to: `/factory/${factoryId}/file-folder/${folderPathUUID[index]}`,
          hasCustomAction: true,
        };
      }
      return resultPath;
    });
    path.unshift({
      text: '最上層',
      to: `/factory/${factoryId}/files`,
      hasCustomAction: true,
    });
    return path;
  },
  setPath(rawPath) {
    if (!rawPath) return '';
    const folderPath = rawPath.split('/');
    let path = '';
    folderPath.forEach((_path, index) => {
      if (index === 0) path = _path;
      if (index !== folderPath.length -1 && index !== 0) {
        path += `/${_path}`;
      }
    });
    return path;
  },
  setFolderListData(rawDataList, filterState) {
    if (!filterState.search) return [];
    return rawDataList.map(rawData => {
      const {
        id,
        folder_path,
        is_secret: isSecret,
        name,
        updated_at,
        created_at,
      } = rawData;
      return {
        id,
        name,
        path: this.setPath(folder_path),
        isSecret,
        createdAt: H_time.getDateDashFormat(created_at, 'YYYY-MM-DD HH:mm:ss'),
        updatedAt: H_time.getDateDashFormat(updated_at, 'YYYY-MM-DD HH:mm:ss'),
      };
    });
  },
  setSubmitEditFolder(rawData, currentFolderId) {
    const {
      name,
      isSecret,
      isPublic,
      scopeRoles,
      scopeAvatars,
      shareFactories: share_factories,
    } = rawData;
    const result = {
      name,
      is_secret: isSecret ? 1 : 0,
      is_public: isPublic ? 1 : 0,
      module: '',
      share_factories,
      users: isPublic ? [] : scopeAvatars,
      user_factory_roles: scopeRoles[0] && scopeRoles[0].length
        ? scopeRoles[0].map(role => {
            return {
              role_id: role,
              role_type: 'factory'
            };
          })
        : [],
      user_factory_role_templates: scopeRoles[1] && scopeRoles[1].length
      ? scopeRoles[1].map(role => {
          return {
            role_id: role,
            role_type: 'template'
          };
        })
      : [],
    };
    if (currentFolderId) result.file_folder = currentFolderId;
    return result;
  },
  setSelectMoveFolder(rawData) {
    const {id: moveFolderId, name, path} = rawData;
    const moveFolderPath = `${path}/${name}`;
    return {moveFolderId, moveFolderPath};
  },
  setSubmitCreateFile(createData, folderId, uploadModule) {
    const {
      name = '',
      des = '',
      remark = '',
      lawList = [],
      attaches = [],
      shareFactories: share_factories = [],
    } = createData;
    const { actVersionAlls, articleVersions } = H_common.setSubmitActAndArticle(lawList);
    const { fileType, file } = attaches[0];
    const resultData = {
      name,
      file_type: fileType,
      file,
      des,
      file_folder: folderId ? folderId : '',
      remark,
      act_version_alls: actVersionAlls,
      article_versions: articleVersions,
      share_factories,
      factory: store.state.app.factory.id,
    };
    if (uploadModule) resultData.module = uploadModule;
    return this.setFormData(resultData);
  },
  setSubmitUpdateFile(rawData) {
    const {
      name,
      des,
      remark,
      lawList,
      isInvalid,
      folderId: file_folder,
      shareFactories: share_factories,
    } = rawData;
    const { actVersionAlls, articleVersions } = H_common.setSubmitActAndArticle(lawList);
    const result = {
      name,
      des,
      remark,
      act_version_alls: actVersionAlls,
      article_versions: articleVersions,
      is_invalid: isInvalid ? true : false,
      file_folder,
      share_factories,
    };
    return result;
  },
  setSubmitVersionUpdateFile(rawData) {
    const {
      name = '',
      des = '',
      remark = '',
      lawList = [],
      folderId: file_folder = '',
      shareFactories: share_factories = [],
      attaches = [],
      fileType = '',
    } = rawData;
    const { actVersionAlls, articleVersions } = H_common.setSubmitActAndArticle(lawList);
    const { fileType: _fileType, file } = attaches[0];
    const result = {
      name,
      file_type: _fileType || fileType,
      file,
      des,
      remark,
      act_version_alls: actVersionAlls,
      article_versions: articleVersions,
      file_folder,
      share_factories,
      factory: store.state.app.factory.id,
    };
    return this.setFormData(result);
  },
  setActionList(rawDataList) {
    return rawDataList.map(rawData => {
      const {
        id,
        action: rawAction,
        created_user: createdUser,
        created_at
      } = rawData;
      let action = '';
      switch(rawAction){
        case 'create_file': action = i18n.t('新增'); break;
        case 'update_file': action = i18n.t('編輯'); break;
        case 'update_path': action = i18n.t('移動'); break;
        case 'create_file_version': action = i18n.t('上傳新版本'); break;
      }
      const result = {
        id,
        action: action ? action : rawAction,
        createdUser,
        createdAt: H_time.getDateDashFormat(created_at, 'YYYY-MM-DD HH:mm:ss'),
      };
      if (
        rawAction === 'update_file' ||
        rawAction === 'update_path' ||
        rawAction === 'create_file_version'
      ) result.info = {icon: 'icon-info'};
      return result;
    })
  },
  setHistoryList(rawDataList) {
    return rawDataList.map(rawData => {
      const {
        name,
        source_url: sourceUrl,
        created_user: createdUser,
        created_at,
        version_number: versionNumber,
        file_type: fileType,
      } = rawData;
      const result = {
        name,
        sourceUrl,
        createdUser,
        createdAt: H_time.getDateDashFormat(created_at, 'YYYY-MM-DD HH:mm:ss'),
        download: {icon: 'icon-cloud-download'},
        versionNumber,
        fileType,
      };
      return result;
    })
  },
  setParentFolderId(rawUUIDPath) {
    let resultParentFolderId = '';
    const folderPathUUID = rawUUIDPath.split('/');
    if (folderPathUUID.length > 1) {
      resultParentFolderId = folderPathUUID[folderPathUUID.length -2];
    }
    return resultParentFolderId;
  },
  setActivityPopup(rawData) {
    const {
      action,
      payload,
      act_version_alls: actVersionAlls,
      article_versions: articleVersions,
      share_factories: shareFactories,
    } = rawData;
    const result = [];
    const formatText = (rawText) => {
      return rawText === null ? `${i18n.t('無')}` : rawText
    }
    if (action === 'update_file') {
      const {
        old_name,
        new_name,
        old_des,
        new_des,
        old_remark,
        new_remark,
        old_is_invalid,
        new_is_invalid,
      } = payload;
      if (old_name !== undefined && new_name !== undefined) result.push({
        type: 'text',
        title: '標題異動',
        before: `[${i18n.t('變更前')}] ${formatText(old_name)}`,
        after: `[${i18n.t('變更後')}] ${formatText(new_name)}`,
      });
      if (old_des !== undefined && new_des !== undefined) result.push({
        type: 'text',
        title: '版本說明異動',
        before: `[${i18n.t('變更前')}] ${formatText(old_des)}`,
        after: `[${i18n.t('變更後')}] ${formatText(new_des)}`,
      });
      if (old_remark !== undefined && new_remark !== undefined) result.push({
        type: 'text',
        title: '備註異動',
        before: `[${i18n.t('變更前')}] ${formatText(old_remark)}`,
        after: `[${i18n.t('變更後')}] ${formatText(new_remark)}`,
      });
      if (old_is_invalid !== undefined && new_is_invalid !== undefined) result.push({
        type: 'text',
        title: '作廢異動',
        before: `[${i18n.t('變更前')}] ${old_is_invalid ? i18n.t('作廢') : i18n.t('使用中')}`,
        after: `[${i18n.t('變更後')}] ${new_is_invalid ? i18n.t('作廢') : i18n.t('使用中')}`,
      });
      if (
        (actVersionAlls && actVersionAlls.length) ||
        (articleVersions && articleVersions.length)) {
        const addLawList = {
          act_version_alls: actVersionAlls.filter(act => act.type === 'add'),
          article_versions: articleVersions.filter(article => article.type === 'add')
        };
        const removeLawList = {
          act_version_alls: actVersionAlls.filter(act => act.type === 'remove'),
          article_versions: articleVersions.filter(article => article.type === 'remove')
        };
        result.push({
          type: 'link',
          title: '法規依據異動',
          add: H_common.setLawList(addLawList),
          remove: H_common.setLawList(removeLawList),
        })
      }
      if (shareFactories && shareFactories.length) {
        const shareItem = {
          type: 'text',
          title: '共享異動',
        };
        const addList = shareFactories.filter(factory => factory.type === 'add').map(factory => factory.name).join(`, `);
        const removeList = shareFactories.filter(factory => factory.type === 'remove').map(factory => factory.name).join(`, `);
        if (addList) shareItem.before = `[${i18n.t('新增')}] ${addList}`;
        if (removeList) shareItem.after = `[${i18n.t('移除')}] ${removeList}`;
        result.push(shareItem);
      }
    } else if (action === 'create_file_version') {
      const {version_number} = payload;
      result.push({
        type: 'text',
        title: '版本異動',
        before: `[${i18n.t('變更前')}] ${version_number - 1}`,
        after: `[${i18n.t('變更後')}] ${version_number}`,
      })
    } else if (action === 'update_path') {
      const {
        file_path,
        file_uuid_path,
        old_file_path,
        old_file_uuid_path,
      } = payload;
      const beforePath = this.setPathWithLink(old_file_path, old_file_uuid_path);
      const afterPath = this.setPathWithLink(file_path, file_uuid_path);
      result.push({
        type: 'path',
        title: '位置異動',
        before: beforePath.slice(0, beforePath.length -1),
        after: afterPath.slice(0, afterPath.length -1),
      })
    }
    return result;
  },
  setOrganizationFactoryList(rawList) {
    if (!rawList || !Array.isArray(rawList)) return [];
    return rawList.map(factory => {
      const newFactory = {
        ...factory,
        disable: factory.is_disabled
      };
      if (factory.child_factories && factory.child_factories.length) {
        newFactory.child_factories = this.setOrganizationFactoryList(factory.child_factories);
      }
      return newFactory;
    });
  },
  setShowInModule(rawDataList) {
    if (!rawDataList || !rawDataList.length) return [];
    const result = rawDataList.map(rawData => {
      const {file, file_version: fileVersion} = rawData;
      const {
        name,
        source_url: url,
        file_type: fileType,
        is_invalid,
        version_number,
        is_compressed = 0,
      } = fileVersion ? fileVersion : file;
      const hasNoFolderScope = url === null && name !== 'invalid scope';
      const hasScope = url !== null;
      return {
        id: file.id,
        versionId: fileVersion ? fileVersion.id : '',
        fileType: hasScope || hasNoFolderScope ? fileType : '',
        isInvalid: is_invalid === 1,
        hasScope,
        name: hasScope || hasNoFolderScope ? name : i18n.t('無權限'),
        url,
        chipList: is_invalid === 1 ? [Spare_file.invalid] : [],
        showMoreBtn: hasScope,
        showDownloadBtn: hasScope,
        isClickable: hasScope || hasNoFolderScope,
        isCompressed: is_compressed ? true : false,
        versionNumber: hasScope || hasNoFolderScope ? version_number : '',
      };
    });
    return result
  },
  setTempFileShowInModule(rawDataList) {
    if (!rawDataList || !rawDataList.length) return [];
    const result = rawDataList.map(url => {
      return {
        id: '',
        versionId: '',
        fileType: this.setFileExtension(url).substring(1),
        isInvalid: false,
        hasScope: true,
        name: this.setFileNameFromUrl(url),
        url,
        chipList: [],
        showMoreBtn: false,
        showDownloadBtn: true,
        isClickable: true,
      };
    });
    return result
  },
  setChooseIndex(rawDataList, fileSourceFile) {
    return rawDataList.map(rawData => {
      const {id, name, created_at, updated_at, file_path, version_number, file_type: fileType, file, is_system, source_url: url} = rawData;
      const textRemark = [this.setPath(file_path)];
      return {
        id: file && file.id ? file.id : id,
        versionId: file ? id : null,
        name,
        textRemark,
        createdAt: H_time.getDateDashFormat(created_at, 'YYYY-MM-DD HH:mm:ss'),
        updatedAt: H_time.getDateDashFormat(updated_at, 'YYYY-MM-DD HH:mm:ss'),
        versionNumber: `ver.${version_number}`,
        isChecked: false,
        fileType,
        hasScope: true,
        url,
        isSystem: is_system === 1,
        showMoreBtn: fileSourceFile === 'unit' ? false : true,
      };
    });
  },
  setSubmitInModule(rawAttachList) {
    if (!rawAttachList || !rawAttachList.length) return [];
    return rawAttachList.map(rawAttach => {
      const {id: file, versionId} = rawAttach;
      return versionId
        ? {
            file,
            file_version: versionId,
          }
        : {file};
    })
  },
  goToFile(FileId, redirect) {
    const factoryId = store.state.app.factory.id;
    const path = `/factory/${factoryId}/file-content/${FileId}`;
    if (redirect) {
      router.push({
        path,
        query: {redirect},
      });
    } else {
      const url = router.resolve({path});
      window.open(url.href, '_blank');
    }
  },
  setCard(rawDataList) {
    if (!rawDataList || !rawDataList.length) return [];
    const result = rawDataList.map(rawData => {
      const {
        id,
        name: title,
        version_number,
        file_path,
        created_at,
        updated_at,
        file_type: fileType,
        source_url: url,
      } = rawData;
      return {
        id,
        title,
        spec: [
          {
            title: '路徑',
            text: this.setPath(file_path),
          },
          {
            title: '版本',
            text: version_number,
          },
          {
            title: '建立時間',
            text: H_time.getDateDashFormat(created_at, 'YYYY-MM-DD HH:mm:ss'),
          },
          {
            title: '更新時間',
            text: H_time.getDateDashFormat(updated_at, 'YYYY-MM-DD HH:mm:ss'),
          },
        ],
        fileType,
        url,
      };
    });
    return result
  },
  setFileIcon(fileType, url) {
    if (fileType) return this.setFileIconFromType(fileType);
    if (url) return this.setFileIconFromUrl(url);
    return require('@/assets/image/thumbnail_file/other-other.png');
  },
  setFormData(rawData) {
    const formData = new FormData();

    const append = (data, prefix = '') => {
      for (const key in data) {
        // 只處理物件自身的屬性，不處理原型鏈
        if (!Object.prototype.hasOwnProperty.call(data, key)) continue;

        const value = data[key];
        // 構建 Laravel 喜歡的格式: prefix[key]
        const formKey = prefix ? `${prefix}[${key}]` : key;

        // 跳過 null 和 undefined
        if (value === null || value === undefined) continue;

        // 優先處理檔案 (File/Blob)，因為它們也是 Object
        if (value instanceof File || value instanceof Blob) {
          formData.append(formKey, value);
        }
        // 處理日期 (Date)
        else if (value instanceof Date) {
          formData.append(formKey, value.toISOString());
        }
        // 處理陣列
        else if (Array.isArray(value)) {
          // 空陣列不傳送
          if (value.length === 0) continue;

          value.forEach((item, index) => {
            // 跳過陣列中的 null/undefined
            if (item === null || item === undefined) return;

            // 如果陣列項目是物件，使用帶索引的 key 並遞迴處理
            if (typeof item === 'object' && !(item instanceof File) && !(item instanceof Blob) && !(item instanceof Date)) {
              append(item, `${formKey}[${index}]`);
            } else {
              // 純值陣列用 [] 格式
              formData.append(`${formKey}[]`, item);
            }
          });
        }
        // 處理布林值
        else if (typeof value === 'boolean') {
          formData.append(formKey, value ? true : false);
        }
        // 處理巢狀物件
        else if (typeof value === 'object') {
          append(value, formKey);
        }
        // 處理基本型別 (String, Number)
        else {
          formData.append(formKey, value);
        }
      }
    };

    append(rawData);
    return formData;
  },
  isTypeImg(fileType) {
    if (!fileType) return false;
    return Spare_file.imageExtensionsWithoutDot.includes(fileType.toLowerCase());
  },
  removeSpecialCharacters(name) {
    const SPECIAL_CHARS_REGEX = /[#?%&/\\=]/g;
    return name.replace(SPECIAL_CHARS_REGEX, '');
  },
}
